import { render, staticRenderFns } from "./CardPaymentProductDetail.vue?vue&type=template&id=1b649273&"
import script from "./CardPaymentProductDetail.vue?vue&type=script&lang=js&"
export * from "./CardPaymentProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports